import "@fortawesome/fontawesome-free/css/all.min.css";
import { useState } from "react";

function Webwasa() {
  const [activeTab, setActiveTab] = useState("methodology");

  return (
    <div>
      {/* -- Banner sec ---- */}
      <div className="page-banner-area">
        <h2>Services</h2>
        <div className="breadcrumbs-services">
          <ul>
            <li>
              <a href="/">Home</a>
            </li>
            <li> OT</li>
          </ul>
        </div>
      </div>
      {/* -- Banner sec ---- */}

      {/* ---- About service section ----- */}
      <div className="about-services-wrap">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12">
              {/* headings */}
              <div className="heading-in mb-5">
                <h1>OT (Operational Technology) Security Testing</h1>
                <p>
                  <b className="sub-heading">Introduction</b>
                  <br />
                  Operational Technology (OT) systems are the backbone of
                  industrial environments — controlling critical infrastructure,
                  manufacturing plants, energy grids, and transportation
                  networks. As these systems become increasingly connected with
                  IT networks, they also become vulnerable to cyberattacks. An
                  OT Security Assessment helps organizations safeguard
                  industrial operations by identifying weaknesses in control
                  systems, communication protocols, and network architecture
                  before adversaries exploit them.
                </p>
              </div>
              {/* headings */}

              <div className="service-card-heading">
                <h1>Why It Matters</h1>
              </div>
              <div className="services-cards-wp">
                {[
                  {
                    icon: "fa-arrows-down-to-people",
                    title: "Critical Infrastructure at Risk",
                    desc: "Attacks on OT systems can disrupt essential services, leading to downtime, safety hazards, or national-level crises.",
                  },
                  {
                    icon: "fa-database",
                    title: "Legacy Systems",
                    desc: "Many OT devices run on outdated or proprietary technologies with limited built-in security.",
                  },
                  {
                    icon: "fa-shield-halved",
                    title: "IT/OT Convergence",
                    desc: "The integration of IT and OT networks increases the attack surface, exposing industrial control systems to traditional cyber threats.",
                  },
                  {
                    icon: "fa-table",
                    title: "Compliance Requirements",
                    desc: "Industries are required to meet standards like NERC-CIP, IEC 62443, NIST 800-82, and ISO 27019.",
                  },
                  {
                    icon: "fa-business-time",
                    title: "Safety First",
                    desc: "OT attacks can move beyond digital disruption to cause physical harm, equipment failure, and human safety risks.",
                  },
                  {
                    icon: "fa-business-time",
                    title: "Business Continuity",
                    desc: "Securing OT environments ensures uninterrupted operations and minimized downtime, protecting revenue and reputation.",
                  },
                ].map((item, i) => (
                  <div className="service-box" key={i}>
                    <div className="service-icon">
                      <i className={`fa-solid ${item.icon}`}></i>
                    </div>
                    <div className="service-card-content">
                      <h3>{item.title}</h3>
                      <p>{item.desc}</p>
                    </div>
                  </div>
                ))}
              </div>

              {/*-------- TAB AND PILL SEC ----------- */}
              <div className="tab-pill-sec-main">
                <div className="tab-inner-contain">
                  <ul className="nav nav-pills">
                    {[
                      { id: "methodology", label: "Methodology" },
                      { id: "keybenefits", label: "Key Benefits" },
                      { id: "deliverables", label: "Deliverables" },
                    ].map((tab) => (
                      <li className="nav-item" key={tab.id}>
                        <button
                          className={`nav-link${activeTab === tab.id ? " active" : ""}`}
                          onClick={() => setActiveTab(tab.id)}
                        >
                          {tab.label}
                        </button>
                      </li>
                    ))}
                  </ul>

                  <div className="tab-content">
                    {/* Methodology */}
                    <div
                      className={`tab-pane fade${activeTab === "methodology" ? " show active" : ""}`}
                      role="tabpanel"
                    >
                      <p>Our OT Security Assessment follows a structured, industry-aligned methodology:</p>
                      <ul>
                        <li><b>Discovery & Asset Mapping :-</b> Identify all OT/ICS assets, devices, and communication flows.</li>
                        <li><b>Threat Modeling :-</b> Analyze possible attack vectors across IT/OT boundaries and industrial networks.</li>
                        <li><b>Vulnerability Assessment :-</b> Evaluate control systems, SCADA, PLCs, HMIs, and industrial networks for known and unknown vulnerabilities.</li>
                        <li><b>Configuration & Policy Review :-</b> Check system hardening, patch levels, access controls, and compliance with OT standards.</li>
                        <li><b>Network Segmentation Analysis :-</b> Assess architecture for isolation of critical assets and protection against lateral movement.</li>
                        <li><b>Protocol & Communication Security Testing :-</b> Examine Modbus, DNP3, OPC, Profinet, BACnet, and other OT protocols for flaws.</li>
                        <li><b>Penetration Simulation (Non-Disruptive) :-</b> Safely simulate real-world cyberattacks to test resilience without impacting operations.</li>
                        <li><b>Compliance Mapping :-</b> Benchmark security posture against NIST, IEC 62443, NERC-CIP, ISO, and sector regulations.</li>
                      </ul>
                    </div>

                    {/* Key Benefits */}
                    <div
                      className={`tab-pane fade${activeTab === "keybenefits" ? " show active" : ""}`}
                      role="tabpanel"
                    >
                      <ul>
                        <li>Protection of critical assets and industrial operations.</li>
                        <li>Stronger compliance with industry-specific regulatory frameworks.</li>
                        <li>Improved visibility into OT asset inventory and network flows.</li>
                        <li>Safer IT/OT integration and reduced attack surface.</li>
                        <li>Enhanced resilience against cyber-physical threats.</li>
                      </ul>
                    </div>

                    {/* Deliverables */}
                    <div
                      className={`tab-pane fade${activeTab === "deliverables" ? " show active" : ""}`}
                      role="tabpanel"
                    >
                      <p>With our OT Security Assessment, you receive:</p>
                      <ul>
                        <li><b>Comprehensive Security Report :-</b> Detailed vulnerabilities with risk ratings and operational impact.</li>
                        <li><b>Remediation Roadmap :-</b> Practical steps for securing OT devices, networks, and systems.</li>
                        <li><b>Compliance Gap Analysis :-</b> Benchmarking against IEC 62443, NERC-CIP, NIST, ISO, and ISA standards.</li>
                        <li><b>Executive Summary :-</b> High-level findings for leadership and risk managers.</li>
                        <li><b>Remediation Workshops :-</b> Guided sessions for OT/ICS teams.</li>
                        <li><b>Follow-Up Validation (Optional) :-</b> Reassessment to confirm that vulnerabilities are resolved.</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              {/*---------- TAB AND PILL SEC ---------- */}

              {/* ------- OUR APPROACH SEC ------ */}
              <div className="our-approach-sec-main">
                <div className="container">
                  <h3>Our Approach</h3>
                  <p>
                    We understand the unique challenges of OT security — where safety, reliability, and uptime are paramount:
                  </p>
                  <ul>
                    <li><b>Industrial Expertise :-</b> Experience across manufacturing, power, oil & gas, utilities, transportation, and critical infrastructure.</li>
                    <li><b>Non-Intrusive Testing :-</b> Specialized techniques that assess security without disrupting operations.</li>
                    <li><b>End-to-End Coverage :-</b> From SCADA, PLCs, HMIs, RTUs, and DCS systems to IT/OT convergence points.</li>
                    <li><b>Standards-Based :-</b> Our assessments align with IEC 62443, NIST 800-82, NERC-CIP, and ISA99.</li>
                    <li><b>Risk-to-Business Focused :-</b> Reports tailored for both technical teams and business executives.</li>
                    <li><b>Remediation Support :-</b> We work closely with OT and IT teams to implement secure configurations and resilience strategies.</li>
                  </ul>
                </div>
              </div>
              {/* ------- OUR APPROACH SEC ------ */}
            </div>
          </div>
        </div>
      </div>
      {/* ---- About service section ----- */}
    </div>
  );
}

export default Webwasa;
